/**
 * @file: useFeedUnreadCount.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useBehaviorSubject } from '@euler/utils/hooks';
import { useFeedUnreadStore } from '../context';

export const useFeedUnreadCount = (): number => {
  const { feedUnreadCount$ } = useFeedUnreadStore();
  const [count] = useBehaviorSubject(feedUnreadCount$);
  return count;
};
